
const TaxChangeEventTracker = {
       
    category: "expense", on: "Misc Expenses", 
      duration: "-1", value: "0", type: "flat", title: "Payroll Tax Change", 
      tableItemChanged: {}, 
      moodPoints: "0", replaceAmtSw: true              
   
}

export default TaxChangeEventTracker;
